import axiosInstance from "../utils/axios";

function getFeaturesApi(merchantCode: string) {
  return axiosInstance
    .get(`/features/v1/availability/${merchantCode}`);
}

export { getFeaturesApi };
